<template>
  <div class="button-container">
    <button @click="handleAddCart">
      Buy Now
    </button>
  </div>
</template>
<script>
import { setCart, setOrder, getCart } from "@/utils/orders";
import CoursesPurchaseResource from "@/views/api/course-purchase.js";
export default {
  name: "ButtonSignIn",
  props: {
    isChange: {
      type: Boolean,
      default: false
    },
    objectData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    async handleAddCart() {
      const res = await this.onGetPaymentAmount(this.objectData?.course_id);
      if (res.error_code !== 0) {
        this.$message.warning(res.error_msg);
        return;
      }
      const data = {
        author: this.objectData?.author || {},
        course_id: this.objectData?.course_id,
        discount_amount: this.objectData?.discount_amount,
        origin_amount: this.objectData?.origin_amount,
        payment_amount: this.objectData?.payment_amount,
        headline: this.objectData?.headline,
        banner: this.objectData?.banner
      };
      setOrder([data]);
      setCart([data, ...getCart()]);
      return this.$router.push("/Orders");
    },
    async onGetPaymentAmount(course_id) {
      const body = { course_ids: [course_id] };
      const res = await CoursesPurchaseResource.GetPaymentAmount(body);
      return res;
    }
  }
};
</script>
<style scoped>
.noactive {
  background: #035ae0;
  color: #ffff;
}
.active {
  background: #ffff;
  color: #035ae0;
}
.button-container button {
  color: #035ae0;
  border: 1px solid #e3e3e3;
  background-color: #f5f9ff;
  border-radius: 35px;
  font-size: 14px;
  font-weight: 600;
  min-width: 51px;
  padding: 5px 20px;
}
</style>
